var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-back",style:(`color:${_vm.type === 1 ? '#fff' : '#232323'}`),on:{"click":_vm.goBack}},[_c('svg-icon',{staticClass:"arrow",attrs:{"icon-class":"arrow-right"}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }